import { ModuleWithProviders, NgModule } from '@angular/core';
import { InputDirective } from './directives/input.directive';
import { EmptyDirective } from './directives/empty.directive';
import { CommandComponent } from './components/command/command';
import { GroupComponent } from './components/group/group';
import { SeparatorComponent } from './components/separator/separator';
import { CommonModule } from '@angular/common';
import { ItemDirective } from './directives/item.directive';
import { A11yModule } from '@angular/cdk/a11y';
import { LoaderDirective } from './directives/loader.directive';
import { ListComponent } from './components/list/list';

const ComponentsAndDirectives = [
  CommandComponent,
  InputDirective,
  EmptyDirective,
  GroupComponent,
  SeparatorComponent,
  ItemDirective,
  LoaderDirective,
  ListComponent,
];
@NgModule({
    imports: [CommonModule, A11yModule, ...ComponentsAndDirectives],
    exports: ComponentsAndDirectives,
})
export class CmdkModule {
  static forRoot(): ModuleWithProviders<CmdkModule> {
    return {
      ngModule: CmdkModule,
    };
  }
}